<div class="flex flex-col bg-[var(--color-bg-primary)] rounded-lg p-4 h-full">
  <div class="flex items-center gap-3 mb-4 pb-3 border-b border-[var(--color-border)]">
    <span class="flex items-center justify-center w-8 h-8 rounded-md shrink-0" [class]="{
      'bg-[rgba(1,116,253,0.1)] text-[var(--color-primary)]': accentColor() === 'primary',
      'bg-[rgba(5,150,105,0.1)] text-emerald-600': accentColor() === 'success',
      'bg-[rgba(217,119,6,0.1)] text-[var(--color-text-warning)]': accentColor() === 'warning',
      'bg-[rgba(220,38,38,0.1)] text-[var(--color-text-error)]': accentColor() === 'danger',
      'bg-[rgba(59,130,246,0.1)] text-blue-600': accentColor() === 'info',
      'bg-[rgba(124,58,237,0.1)] text-violet-600': accentColor() === 'violet'
    }">
      <mat-icon class="text-lg w-5 h-5" [class]="iconClasses()" [style.color]="iconColor()">{{ icon() }}</mat-icon>
    </span>
    <h3 class="text-sm font-semibold text-[var(--color-text-primary)] m-0 tracking-tight">{{ title() }}</h3>
  </div>
  <div class="flex-1 flex flex-col">
    <ng-content></ng-content>
  </div>
</div>
